import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { ModalBody } from "react-bootstrap";
import ModalHeader from "react-bootstrap/esm/ModalHeader";

import "./SizeGuideModal.css";
import FullSizeGuideContent from "./FullSizeGuideContent";
import SizeGuideContent from "./SizeGuideContent";
import { appGetSizeChart } from "../../../services/ProductService";
import CrossButton from "../../Common/CrossButton";
import { useQuery } from "react-query";
import { isMobile } from "react-device-detect";

Modal.setAppElement("body");

function SizeGuideModal({ productId, mobileSelect2Ref,setaddToBagButtonDisplayStatusfunction }) {
  const [isModelOpen, setIsModalOpen] = useState(false);
  const [sizeGuideData, setSizeGuideData] = useState({});
  const [viewFullSize, setViewFullSize] = useState(false);
  const [windowOffset, setwindowOffset] = useState();

  const { data } = useQuery(
    ["sizeChart", productId],
    () =>
      appGetSizeChart(productId).then((res) => {
        res = JSON.parse(res?.data);
        return res;
      }),
    {
      enabled: isModelOpen,
    }
  );

  useEffect(() => {
    setSizeGuideData(data);
  }, [data]);

  const toggle = () => {
    if (!isModelOpen) {
      if (mobileSelect2Ref != null && mobileSelect2Ref.current != null) {
        mobileSelect2Ref.current.hide();
        setaddToBagButtonDisplayStatusfunction("none");
      }
    }
    setIsModalOpen(!isModelOpen);
    setwindowOffset(window.scrollY);
    document.body.setAttribute(
      "style",
      `position: fixed; top: -${windowOffset}px;left:0;right:0;`
    );
  };

  const setSizeGuidModalClose = () => {
    setIsModalOpen(false);
    document.body.setAttribute("style", "");
    window.scrollTo(0, windowOffset);
    if(isMobile){
      if(isModelOpen){
    //     if (mobileSelect2Ref != null && mobileSelect2Ref.current != null) {        
    //       mobileSelect2Ref.current.show();
    //     }
        setaddToBagButtonDisplayStatusfunction("block");
      }
    }  
  };

  const viewFullSizeCb = (isFullView) => {
    setViewFullSize(isFullView);
  };

  const customStyles = {
    content: {
      width: "600px",
    },
    overlay: { zIndex: "9999", backgroundColor: "rgb(0 0 0 / 75%)" },
  };

  return (
    <>
      {isMobile ? 
        <button className="btn-blank" onClick={toggle}>
          <span style={{float:"left"}}>View Size Guide</span>
          <span className="btn-blank mb-wishlist" style={{float:"right"}}>
            <img 
              src={
                process.env.PUBLIC_URL +
                "/assets/images/icons/arrow-right.png"
              }
              alt=""
              />
          </span>
        </button>
      :
        <button className="btn-blank" onClick={toggle}>
          Size Guide
        </button>
      }
      <Modal
        isOpen={isModelOpen}
        toggle={toggle}
        style={customStyles}
        onRequestClose={() => setSizeGuidModalClose()}
        shouldCloseOnOverlayClick={true}
        id="size_guide_modal"
      >
        <ModalHeader>
          {viewFullSize && (
            <button className="btn-blank" onClick={() => viewFullSizeCb(false)}>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/icons/angle-arrow-left.png"
                }
                className="back-btn-newsletter"
                alt=""
              />
            </button>
          )}

          {(!viewFullSize && isMobile)? (
            <button className="btn-blank" onClick={() => setSizeGuidModalClose()}>
              <img
                src={
                  process.env.PUBLIC_URL +
                  "/assets/images/icons/angle-arrow-left.png"
                }
                className="back-btn-newsletter"
                alt=""
              />
            </button>
          ):(
            ""
          )
          }

          {/* <h3 className={`${viewFullSize ? " view-full-size-header text-left" : "text-left"}`}> */}
          <h3 className="text-center">
            {viewFullSize ? "View Full Size Guide" : "Size Guide"}
          </h3>

          {!isMobile? (
            <CrossButton onClick={() => setSizeGuidModalClose()} />
          ):(
            ""
          )
          }          
        </ModalHeader>
        <ModalBody>
          <SizeGuideContent
            sizeGuideData={sizeGuideData}
            isFullSize={viewFullSize}
            viewFullSizeCb={viewFullSizeCb}
          />
          <FullSizeGuideContent
            sizeGuideData={sizeGuideData}
            isFullSize={viewFullSize}
            viewFullSizeCb={viewFullSizeCb}
          />
        </ModalBody>
      </Modal>
    </>
  );
}

export default SizeGuideModal;
